// extracted by mini-css-extract-plugin
export default {"summaryValue":"summaryValue___Vt9bZ","summaryLabel":"summaryLabel___RfRte"};